import { ActionTypes } from "@/App/constants/actionTypes";
import { Action } from "@/App/actions";
import { PricingLevelsTypes, GeneralTypes } from "@/types";

export interface PricingLevelsListState {
  pricingLevelsOptions: GeneralTypes.QueryOptions;
  pricingLevels: PricingLevelsTypes.PricingLevelAPIResponse;
}

const DEFAULT_PRICING_LEVELS_LIST_STATE: PricingLevelsListState = {
  pricingLevelsOptions: {
    page_number: 1,
    results_per_page: 1000,
  },
  pricingLevels: {
    results: [],
    result_count: null,
  },
};

export default (state: PricingLevelsListState = DEFAULT_PRICING_LEVELS_LIST_STATE, action: Action): {} => {
  if (action.type === ActionTypes.LIST_PRICING_LEVELS) {
    return {
      ...state,
      pricingLevelsOptions: action.payload,
    };
  } else if (action.type === ActionTypes.LIST_PRICING_LEVELS_RESULTS) {
    return {
      ...state,
      pricingLevels: action.payload,
    };
  } else {
    return state;
  }
};
